import WorkerRecentServicesView from "../LatestServices/components/WorkerRecentServicesView";
import "../LatestServices/LatestServices.scss";

export default function ServiceRecent() {
  return <WorkerRecentServicesView />;
}
